<template>
  <div>
    <div class="text-right">
      <template>
        <v-card color="grey">
          <v-toolbar color="grey" dark>
            <v-btn outlined small fab color="white" @click="goback()">
              <v-icon>mdi-arrow-left-bold</v-icon>
            </v-btn>

            <v-toolbar-title class="ml-2">Venue</v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->
            <v-btn medium color="primary" @click="New()">
              <v-icon>mdi-plus</v-icon>
              NEW
            </v-btn>

            <!-- <v-btn medium color="error" class="ml-2" @click="Reload(this.$store.state.eventInfo.EventId)">VIEW</v-btn> -->
          </v-toolbar>
        </v-card>
        <v-data-table
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
              class="ml-4 mr-4 mb-5"
            ></v-text-field>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              @click="editItem(item)"
            >
              <v-icon left>mdi-pencil</v-icon>
              Edit
            </v-btn>

            <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              @click="AddStand(item)"
            >
              <v-icon left>mdi-plus</v-icon>
              Stand
            </v-btn>

            <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              @click="deleteItem(item)"
            >
              <v-icon left>mdi-delete</v-icon>
              Delete
            </v-btn>

            <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              @click="AddUser(item)"
            >
              <v-icon left>mdi-account</v-icon>
              User
            </v-btn>

            <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
          </template>
          <template v-slot:no-data>
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            No Record(s)
          </template>
        </v-data-table>
      </template>

      <v-navigation-drawer
        v-model="sheet"
        right
        persistent
        fixed
        style="width: 100%; max-width: 800px; margin: auto"
      >
        <v-sheet class="text-center" min-height="200px" color="#cccccc">
          <div class="py-3 text-left">
            <v-card
              flat
              max-width="800px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                {{ EntryMode }} {{ VenueID }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon color="grey darken-2" @click="sheet = !sheet"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <!-- <v-select
                        outlined
                        v-model="SelEvent"
                        :items="arrEvent"
                        item-text="event_name"
                        item-value="event_id"
                        label="Select Event"
                        dense
                        :rules="[(v) => !!v || 'Event is required']"
                        required
                        hide-details
                        full-width
                      ></v-select> -->

                      {{ this.$store.state.eventInfo.EventName }}
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.venue_name"
                        label="Venue Name*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        :items="selvenueType"
                        v-model="venueType"
                        dense
                        label="Venue Type"
                        hide-details
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        :items="selstandType"
                        v-model="standType"
                        dense
                        label="Stand Type"
                        hide-details
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="postBody.stadium_name"
                        label="Stedium Name*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        label="Address*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.venue_address"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        label="Prefix*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.prefix"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="postBody.event_date"
                        label="Event Date*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-card outlined>
                        <v-subheader>Set Deadline</v-subheader>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-dialog
                                ref="dialog1"
                                v-model="modal"
                                :return-value.sync="date"
                                persistent
                                width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    outlined
                                    v-model="date"
                                    label="Deadline (Date)"
                                    prepend-icon="mdi-calendar"
                                    dense
                                    readonly
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  :min="new Date().toISOString().slice(0, 10)"
                                  v-model="date"
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="modal = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.dialog1.save(date)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-dialog
                                ref="dialog"
                                v-model="modal2"
                                :return-value.sync="time"
                                persistent
                                width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    outlined
                                    v-model="time"
                                    label="Deadline (Time)"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    dense
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    hide-details
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="modal2"
                                  v-model="time"
                                  full-width
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="modal2 = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.dialog.save(time)"
                                  >
                                    OK
                                  </v-btn>
                                </v-time-picker>
                              </v-dialog>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        label="Contact Person Name*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.contact_name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        label="Contact Person Email*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.contact_email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        label="Contact Person Mobile*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.contact_no"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        label="Media Manager Name*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.media_manager_name"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        label="Media Manager Email*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.media_manager_email"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        label="Media Manager Cotact*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.media_contact_no"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        label="Google Location*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.google_location"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>

                <v-card-actions class="justify-center">
                  <v-btn
                    color="success"
                    :disabled="!valid"
                    raised
                    dark
                    large
                    @click="Save()"
                  >
                    SAVE
                  </v-btn>
                </v-card-actions>

                <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
              </v-form>
            </v-card>
          </div>
        </v-sheet>
      </v-navigation-drawer>

      <v-navigation-drawer
        v-model="sheetStand"
        right
        persistent
        fixed
        style="width: 100%; max-width: 800px; margin: auto"
      >
        <v-sheet class="text-center" min-height="200px" color="#cccccc">
          <div class="py-3 text-left">
            <v-card
              flat
              max-width="800px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                {{ EntryModeLoadStand }} {{ VenueID }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon
                    color="grey darken-2"
                    @click="sheetStand = !sheetStand"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-data-table
                        :headers="headersStand"
                        :items="dessertsStand"
                        sort-by="calories"
                        class="elevation-0"
                        :search="searchStand"
                        :loading="loadingstatus"
                        loading-text="Loading... Please wait"
                      >
                        <template v-slot:top>
                          <v-toolbar color="transparent" flat>
                            <v-text-field
                              v-model="searchStand"
                              label="Search"
                              single-line
                              hide-details
                              class="ml-4 mr-4 mb-5"
                            ></v-text-field>
                            <v-spacer></v-spacer>

                            <v-btn medium color="primary" @click="NewStand()">
                              <v-icon>mdi-plus</v-icon>
                              NEW
                            </v-btn>
                          </v-toolbar>
                        </template>

                        <template v-slot:item.actions="{ item }">
                          <v-icon
                            small
                            class="mr-2"
                            @click="editItemStand(item)"
                            >mdi-pencil</v-icon
                          >
                          <v-icon small @click="deleteItem(item)"
                            >mdi-delete</v-icon
                          >
                        </template>
                        <template v-slot:no-data>
                          <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                          No Record(s)
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>

                <v-card-actions class="justify-center">
                  <v-btn
                    color="success"
                    :disabled="!valid"
                    raised
                    dark
                    large
                    @click="Save()"
                  >
                    SAVE
                  </v-btn>
                </v-card-actions>

                <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
              </v-form>
            </v-card>
          </div>
        </v-sheet>
      </v-navigation-drawer>

      <v-navigation-drawer
        v-model="sheetAddStand"
        right
        persistent
        temporary
        fixed
        style="width: 100%; max-width: 800px; margin: auto"
      >
        <v-sheet class="text-center" min-height="200px" color="#cccccc">
          <div class="text-left">
            <v-card
              flat
              max-width="800px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                {{ EntryModeStand }} {{ VenueID }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon
                    color="grey darken-2"
                    @click="sheetAddStand = !sheetAddStand"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBodyStand.stand_name"
                        label="Stand Name*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBodyStand.print_text"
                        label="Print Text*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        label="Gate No*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBodyStand.gate_no"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        label="Stand Color*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBodyStand.stand_color"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-card-actions class="justify-center">
                    <v-btn
                      color="success"
                      :disabled="!valid"
                      raised
                      dark
                      large
                      @click="SaveStand()"
                    >
                      SAVE
                    </v-btn>
                  </v-card-actions>
                </v-container>

                <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
              </v-form>
            </v-card>
          </div>
        </v-sheet>
      </v-navigation-drawer>

     

      <v-navigation-drawer
        v-model="sheetUser"
        right
        persistent
        fixed
        style="width: 100%; max-width: 900px; margin: auto"
      >
        <v-sheet class="text-center" min-height="200px" color="#cccccc">
          <div class="py-3 text-left pb-0 pt-0">
            <v-card
              flat
              max-width="900px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                {{ EntryModeLoadStand }} {{ VenueID }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon color="grey darken-2" @click="sheetUser = !sheetUser"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-data-table
                        :headers="headersUser"
                        :items="dessertsUser"
                        sort-by="calories"
                        class="elevation-0"
                        :search="searchUser"
                        :loading="loadingstatus"
                        loading-text="Loading... Please wait"
                      >
                        <template v-slot:top>
                          <v-toolbar color="transparent" flat>
                            <v-text-field
                              v-model="searchUser"
                              label="Search"
                              single-line
                              hide-details
                              class="ml-4 mr-4 mb-5"
                            ></v-text-field>
                            <v-spacer></v-spacer>

                            <v-btn medium color="primary" @click="NewUser()">
                              <v-icon>mdi-plus</v-icon>
                              NEW
                            </v-btn>
                          </v-toolbar>
                        </template>

                        <template v-slot:item.actions="{ item }">
                          <v-icon small class="mr-2" @click="editItemUser(item)"
                            >mdi-pencil</v-icon
                          >
                          <v-icon small @click="deleteItemUser(item)"
                            >mdi-delete</v-icon>
                            <v-icon medium @click="btnaccess(item)">mdi-account-check</v-icon>

                        </template>
                        <template v-slot:no-data>
                          <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                          No Record(s)
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>

                <!-- <v-card-actions class="justify-center">
                  <v-btn
                    color="success"
                    :disabled="!valid"
                    raised
                    dark
                    large
                    @click="Save()"
                  >
                    SAVE
                  </v-btn>
                </v-card-actions> -->

                <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
              </v-form>
            </v-card>
          </div>
        </v-sheet>
      </v-navigation-drawer>

      <v-navigation-drawer
        v-model="sheetAddUser"
        right
        persistent
        fixed
        style="width: 100%; max-width: 800px; margin: auto"
      >
        <v-sheet class="text-center" min-height="200px" color="#cccccc">
          <div class="text-left">
            <v-card
              flat
              max-width="800px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                {{ EntryModeUser }} {{ VenueID }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon
                    color="grey darken-2"
                    @click="sheetAddUser = !sheetAddUser"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBodyUser.name"
                        label="Name*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBodyUser.email"
                        label="Email*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBodyUser.pass"
                        label="Password*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        :items="userTypeUser"
                        v-model="SeluserTypeUser"
                        label="User Type"
                        dense
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        :items="EditDeadlineUser"
                        v-model="SelEditDeadlineUser"
                        label="Edit Deadline"
                        dense
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-card-actions class="justify-center">
                    <v-btn
                      color="success"
                      :disabled="!valid"
                      raised
                      dark
                      large
                      @click="SaveUser()"
                    >
                      SAVE
                    </v-btn>
                  </v-card-actions>
                </v-container>

                <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
              </v-form>
            </v-card>
          </div>
        </v-sheet>
      </v-navigation-drawer>


 <v-navigation-drawer  v-model="sheetUseraccess" temporary right fixed persistent style="width:100%;max-width:700px;margin:auto">
<v-sheet  min-height="200px" >
  <div class="text-left">
  <v-card flat
              max-width="700px"
              style="width: 100%; margin:auto"
              class="pa-3">
    <v-toolbar color="transparent" flat>
       {{ EntryModeLoadStand }} {{ VenueID }} {{ EventIDPermanent }}
       <v-spacer></v-spacer>
        <v-icon @click="sheetUseraccess = !sheetUseraccess">mdi-close</v-icon>
    </v-toolbar>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" sm="12" md="8">
      <v-select outlined v-model="selcompany"></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn outlined  @click="btnsearchforbind">Search</v-btn>
      </v-col>
    </v-row>
    
  </v-card>
  </div>
</v-sheet>
      </v-navigation-drawer>


    </div>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
//import { mapMutations } from 'vuex'
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      sheetUseraccess:false,
      date: "",
      time: "",
      SelEvent: "",
      venueType: "",
      standType: "",
      arrEvent: [],
      modal: false,
      modal2: false,
      valid: false,
      snackbar: false,
      snackbartext: "",
      snackbarcolor: "primary",
      mode: "NEW",
      newmode: true,
      sheet: false,
      sheetStand: false,
      sheetUser: false,
      sheetAddStand: false,
      sheetAddUser: false,
      EntryMode: "",
      EntryModeStand: "",
      EntryModeUser: "",
      search: "",
      searchStand: "",
      searchUser: "",
      loadingstatus: false,
      isUploading: false,
      getcity_id: "",
      VenueID: "",
      EventIDPermanent:"",
      VenueIDPermaent: "",
      SelCity: "",
      ItemCity: [],
      selstandType: [
        { text: "zone", value: "zone" },
        { text: "stand", value: "stand" },
      ],
      selvenueType: [
        { text: "Local", value: "Local" },
        { text: "Central", value: "Central" },
      ],

      postBodyStand: {
        stand_name: "",
        print_text: "",
        gate_no: "",
        stand_color: "",
        venue_id: 0,
      },

      postBody: {
        event_id: 0,
        venue_name: "",
        venue_type: "",
        prefix: "",
        stadium_name: "",
        venue_address: "",
        google_location: "",
        contact_name: "",
        contact_email: "",
        contact_no: "",
        media_manager_name: "",
        media_manager_email: "",
        media_contact_no: "",
        deadline: "",
        stand_type: "",
        event_date: "",
      },

      headers: [
        {
          text: "venue_id",
          align: "start",
          sortable: false,
          value: "venue_id",
        },
        { text: "venue_name", value: "venue_name" },
        { text: "Venue Type", value: "venue_type" },
        { text: "Stand Type", value: "stand_type" },
        { text: "Stadium", value: "stadium_name" },

        { text: "Actions", value: "actions", sortable: false },
      ],
      desserts: [],

      headersStand: [
        { text: "stand_id", value: "stand_id" },
        { text: "stand_name", value: "stand_name" },
        { text: "print_text", value: "print_text" },
        { text: "gate_no", value: "gate_no" },
        { text: "stand_color", value: "stand_color" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dessertsStand: [],

      dessertsUser: [],
      headersUser: [
        { text: "Eid", value: "eaid" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "User Type", value: "u_type" },
        { text: "Edit Deadline Access", value: "edit_deadline" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      postBodyUser: {
        name: "",
        email: "",
        pass: "",
        event_id: 0,
        venue_id: 0,
        u_type: "",
        edit_deadline: "",
        created_by: 1,
      },

      SeluserTypeUser: "",
      userTypeUser: [
        { text: "Admin", value: "Admin" },
        { text: "SubAdmin", value: "SubAdmin" },
        { text: "DnaAdmin", value: "DnaAdmin" },
        { text: "PrintAdmin", value: "PrintAdmin" },
        { text: "MediaAdmin", value: "MediaAdmin" },
         { text: "Scanner", value: "Scanner" },
      ],
      SelEditDeadlineUser: "",
      EditDeadlineUser: [
        { text: "Yes", value: "Y" },
        { text: "No", value: "N" },
      ],
    };
  },
  mounted() {
    this.$store.commit("setPageTitle", "Venue Master");
    this.Reload(this.$store.state.eventInfo.EventID);
    //  this.bindCity();
  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    Reload: function (eid) {
      this.loadingstatus = true;
      axios
        .get(this.$apiPath + "Venue/GetByEId/" + eid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.desserts = res.data.result;
          this.loadingstatus = false;
        })
        .catch()
        .finally();
    },
    goback() {
      this.$router.push("/admin/Events");
    },
    AddStand(item) {
      console.log(item);
      this.sheetStand = true;
      this.EntryModeLoadStand = item.venue_name + ", " + item.stadium_name;
      this.VenueIDPermaent = item.venue_id;
      this.StandReload(item.venue_id);
    },

    bindCompanytype:async function(eid)
    {
      await axios
      .get(this.$apiPath + "CompanyType/GetByEventId/" + eid,{
        headers:{ApiKey:this.$aKey}
      }
      )
      .then((res)=>{
console.log(res);
      })
    },

    AddUser(item) {
      console.log(item);
      this.sheetUser = true;
      this.EntryModeLoadStand = item.venue_name + ", " + item.stadium_name;
      this.VenueIDPermaent = item.venue_id;
      //this.StandReload(item.venue_id);
      this.UserReload(item.event_id, item.venue_id);
    },
    btnaccess(item){
//console.log(item.event_id);
this.EventIDPermanent=item.event_id;
this.sheetUseraccess=true;
    },

    editItemUser(item) {
      this.EntryModeUser = "Edit User";

      this.VenueID = item.eaid;
      this.postBodyUser.name = item.name;
      this.postBodyUser.email = item.email;
      this.postBodyUser.pass = item.pass;
      this.SeluserTypeUser = item.u_type;
      this.SelEditDeadlineUser = item.edit_deadline;

      this.sheetAddUser = true;
      //  this.postBody.city_id = parseInt(this.SelCity.city_id);
      //  console.log(this.postBody);
    },
    btnsearchforbind(){
this.bindCompanytype()
    },

    New() {
      this.EntryMode = "New Venue";
      this.ClearItem();
      // this.bindCity();
      this.bindevent();
      this.sheet = true;
    },

    NewStand() {
      this.EntryModeStand = "New Stand";
      this.sheetAddStand = true;
    },

    NewUser() {
      this.EntryModeUser = "New User";
      this.sheetAddUser = true;
    },

    SaveUser() {
      this.$refs.form.validate();
      this.postBodyUser.venue_id = parseInt(this.VenueIDPermaent);
      this.postBodyUser.event_id = parseInt(
        this.$store.state.eventInfo.EventID
      );
      this.postBodyUser.u_type = this.SeluserTypeUser;
      this.postBodyUser.edit_deadline = this.SelEditDeadlineUser;
      console.log(this.postBodyUser);
      if (this.editedIndex > -1) {
        Object.assign(this.dessertsUser[this.editedIndex], this.editedItem);
      } else {
        this.dessertsUser.push(this.editedItem);
        if (this.EntryModeUser == "New User") {
          axios
            .post(this.$apiPath + "EventAdmin", this.postBodyUser, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                this.showSnackbar("Success", "User Created!");
                // this.ClearItem();

                this.UserReload(
                  this.$store.state.eventInfo.EventID,
                  this.VenueIDPermaent
                );
                this.sheetAddUser = false;
              }
            })
            .catch()
            .finally();
        } else {
          axios
            .put(
              this.$apiPath + "EventAdmin/" + this.VenueID,
              this.postBodyUser,
              {
                headers: { Appkey: this.$aKey },
              }
            )
            .then((res) => {
              if (res.data.status == "Success") {
                // console.log(this.postBodyUpdate);
                this.showSnackbar("Success", "User Updated!");
                //  this.ClearItem();
                this.sheetAddUser = false;
                this.UserReload(
                  this.$store.state.eventInfo.EventID,
                  this.VenueIDPermaent
                );
              }
            })
            .catch()
            .finally();
        }
      }
      //  this.close();
    },

    deleteItemUser(item) {
      alert(item.eaid);
      //const index = this.desserts.indexOf(item);
      if (confirm("Are you sure you want to delete this User?")) {
        axios
          .delete(this.$apiPath + "EventAdmin/" + item.eaid, {
            headers: { Appkey: this.$aKey },
          })
          .then(() => {
            // this.desserts = res.data.result;
            this.showSnackbar("Success", "User Deleted !");
            this.sheetAddUser = false;
            this.UserReload(
              this.$store.state.eventInfo.EventID,
              this.VenueIDPermaent
            );
          })
          .catch()
          .finally();
      }
    },

    SaveStand() {
      this.$refs.form.validate();

      if (this.editedIndex > -1) {
        Object.assign(this.dessertsStand[this.editedIndex], this.editedItem);
      } else {
        this.dessertsStand.push(this.editedItem);
        if (this.EntryModeStand == "New Stand") {
          this.postBodyStand.venue_id = parseInt(this.VenueIDPermaent);
          console.log(this.postBodyStand);
          axios
            .post(this.$apiPath + "stand", this.postBodyStand, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                this.showSnackbar("Success", "Stand Created!");
                // this.ClearItem();

                this.StandReload(this.VenueIDPermaent);
                this.sheetAddStand = false;
              }
            })
            .catch()
            .finally();
        } else {
          axios
            .put(this.$apiPath + "stand/" + this.VenueID, this.postBodyStand, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                // console.log(this.postBodyUpdate);
                this.showSnackbar("Success", "Stand Updated!");
                //  this.ClearItem();
                // alert(this.VenueIDPermaent);
                this.sheetAddStand = false;
                this.StandReload(this.VenueIDPermaent);
              }
            })
            .catch()
            .finally();
        }
      }
      //  this.close();
    },

    Save() {
      this.$refs.form.validate();
      this.postBody.deadline = this.date + " " + this.time;

      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
        if (this.EntryMode == "New Venue") {
          this.postBody.event_id = parseInt(
            this.$store.state.eventInfo.EventID
          );
          this.postBody.venue_type = this.venueType;
          this.postBody.stand_type = this.standType;
          // console.log("hi");
          console.log(this.postBody);
          axios
            .post(this.$apiPath + "venue", this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                this.showSnackbar("Success", "Venue Created!");
                // this.ClearItem();
                this.Reload(this.$store.state.eventInfo.EventID);
                this.sheet = false;
              }
            })
            .catch()
            .finally();
        } else {
          this.postBody.event_id = parseInt(
            this.$store.state.eventInfo.EventID
          );
          this.postBody.venue_type = this.venueType;
          this.postBody.stand_type = this.standType;
          console.log("V_Edit",this.postBody);
          axios
            .put(this.$apiPath + "venue/" + this.VenueID, this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                // console.log(this.postBodyUpdate);
                this.showSnackbar("Success", "Venue Updated!");
                //  this.ClearItem();
                this.sheet = false;
                this.Reload(this.$store.state.eventInfo.EventID);
              }
            })
            .catch()
            .finally();
        }
      }
      //  this.close();
    },

    editItemStand(item) {
      this.EntryModeStand = "Edit Stand";
      this.VenueID = item.stand_id;
      this.postBodyStand.stand_name = item.stand_name;
      this.postBodyStand.print_text = item.print_text;
      this.postBodyStand.gate_no = item.gate_no;
      this.postBodyStand.stand_color = item.stand_color;

      this.sheetAddStand = true;
      //  this.postBody.city_id = parseInt(this.SelCity.city_id);
      //  console.log(this.postBody);
    },

    editItem(item) {
      console.log(item);
      this.bindevent();
      this.EntryMode = "Edit Venue";
      this.VenueID = item.venue_id;

      this.SelEvent = item.event_id;
      this.postBody.prefix = item.prefix;
      this.postBody.event_date = item.venue_date;
      this.postBody.contact_email = item.contact_email;
      this.postBody.contact_no = item.contact_no;
      this.postBody.media_manager_name = item.media_manager_name;
      this.postBody.media_manager_email = item.media_manager_email;
      this.postBody.media_contact_no = item.media_contact_no;
      this.postBody.contact_name = item.contact_name;
      this.postBody.stadium_name = item.stadium_name;
      this.postBody.venue_address = item.venue_address;
      this.postBody.venue_name = item.venue_name;
      this.postBody.google_location = item.google_location;
      this.venueType = item.venue_type;
      this.standType = item.stand_type;

      this.date = moment(item.deadline, "YYYY-MM-DD").format("YYYY-MM-DD");
      this.time = moment(item.deadline).format("HH:mm");

      // this.SelCity.city_id = item.city_id;
      this.SelCity = item.city_id;
      this.getcity_id = item.city_id;
      //  this.ClearItem();
      // this.bindCity();
      this.sheet = true;
      //  this.postBody.city_id = parseInt(this.SelCity.city_id);
      //  console.log(this.postBody);
    },

    StandReload: function (vid) {
      this.loadingstatus = true;
      axios
        .get(this.$apiPath + "Stand/GetStandByVid/" + vid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.dessertsStand = res.data.result;
          this.loadingstatus = false;
        })
        .catch()
        .finally();
    },

    UserReload: function (eid, vid) {
      this.loadingstatus = true;
      axios
        .get(this.$apiPath + "EventAdmin/GetByEIdVID/" + eid + "/" + vid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.dessertsUser = res.data.result;
          // console.log(res.data.result);
          this.loadingstatus = false;
        })
        .catch()
        .finally();
    },

    ClearItem() {
      this.EntryMode = "New Venue";
      this.VenueID = "";

      this.postBody.prefix = "";
      this.postBody.event_date = "";
      this.postBody.contact_email = "";
      this.postBody.contact_no = "";
      this.postBody.media_manager_name = "";
      this.postBody.media_manager_email = "";
      this.postBody.media_contact_no = "";
      this.postBody.contact_name = "";
      this.postBody.stadium_name = "";
      this.postBody.venue_address = "";
      this.postBody.venue_name = "";
      this.postBody.google_location = "";
      this.SelEvent = "";
      this.venueType = "";
      this.standType = "";
    },

    deleteItem(item) {
      //alert(item.Vendor_Id);
      const index = this.desserts.indexOf(item);
      if (confirm("Are you sure you want to delete this Stand?")) {
        // alert(item.stand_id);
        axios
          .delete(this.$apiPath + "stand/" + item.stand_id, {
            headers: { Appkey: this.$aKey },
          })
          .then(() => {
            // this.desserts = res.data.result;
            this.showSnackbar("Success", "Stand Deleted !");
            //this.Reload(this.$store.state.eventInfo.EventID);
            this.StandReload(this.VenueIDPermaent);
          })
          .catch()
          .finally();
      }
      this.desserts.splice(index, 1);
      this.Reload(this.$store.state.eventInfo.EventID);
    },

    bindevent: async function () {
      await axios
        .get(this.$apiPath + "Event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.arrEvent = res.data.result;
        })
        .catch()
        .finally();
    },
  },
};
</script>

<style>
</style>